<div class="geo-gallery">
  <div
    class="geo-gallery__loading"
    *ngIf="state.loading() && !state.items().length">
    <app-loading
      [loading]="true"
      width="48px"
      height="48px"></app-loading>
  </div>

  <div
    class="geo-gallery__message geo-gallery__message--error"
    *ngIf="state.loadFailed()">
    {{ "UPLOADED_GEO_IMAGES.GALLERY_ERROR_LOAD" | translate }}
  </div>

  <div
    class="geo-gallery__cards"
    *ngIf="cards().length">
    <div
      class="geo-card"
      *ngFor="let card of cards(); trackBy: trackById"
      [class.geo-card--selected]="card.isSelected"
      (click)="onCardClick(card.item)">
      <div class="geo-card__thumbnail">
        <img
          [src]="card.thumbnailUrl"
          [alt]="card.item.title"
          loading="lazy"
          (error)="onImageError($event)" />
        <span class="geo-card__kind">
          {{ (card.item.imageKind === "Raster" ? "UPLOADED_GEO_IMAGES.KIND_RASTER" : "UPLOADED_GEO_IMAGES.KIND_PHOTO") | translate }}
        </span>
      </div>

      <div class="geo-card__body">
        <div
          class="geo-card__title"
          [title]="card.item.title">
          {{ card.item.title }}
        </div>
        <div class="geo-card__row">
          {{ card.item.captureDateUtc ? (card.item.captureDateUtc | date: "dd.MM.yyyy HH:mm") : "-" }}
        </div>
        <div
          class="geo-card__row geo-card__row--muted"
          [title]="card.regionPath">
          {{ card.regionPath || ("UPLOADED_GEO_IMAGES.NO_REGION" | translate) }}
        </div>
        <div
          class="geo-card__row geo-card__row--muted"
          [title]="card.tagsText">
          {{ "UPLOADED_GEO_IMAGES.MODAL_TAGS" | translate }}: {{ card.tagsText || ("UPLOADED_GEO_IMAGES.NO_TAGS" | translate) }}
        </div>
      </div>

      <div class="geo-card__actions">
        <button
          type="button"
          class="geo-card__action"
          [title]="'UPLOADED_GEO_IMAGES.ACTION_PREVIEW' | translate"
          (click)="openPreview(card.item, $event)">
          <i class="pi pi-search-plus"></i>
        </button>
        <button
          type="button"
          class="geo-card__action"
          [title]="'UPLOADED_GEO_IMAGES.ACTION_EDIT' | translate"
          (click)="openEdit(card.item, $event)">
          <i class="pi pi-pencil"></i>
        </button>
        <button
          type="button"
          class="geo-card__action geo-card__action--danger"
          [title]="'UPLOADED_GEO_IMAGES.ACTION_DELETE' | translate"
          (click)="openDelete(card.item, $event)">
          <i class="pi pi-trash"></i>
        </button>
      </div>
    </div>
  </div>

  <div
    class="geo-gallery__message"
    *ngIf="!state.loading() && !state.loadFailed() && !state.items().length">
    <img
      src="assets/icons/main/light/upload-imgs.svg"
      alt="" />
    <p>{{ "UPLOADED_GEO_IMAGES.GALLERY_EMPTY" | translate }}</p>
  </div>

  <div
    class="geo-gallery__footer"
    *ngIf="state.items().length">
    <span class="geo-gallery__total">{{ "UPLOADED_GEO_IMAGES.GALLERY_TOTAL" | translate: { count: state.total() } }}</span>
    <p-paginator
      *ngIf="state.items().length > state.pageSize"
      [first]="(state.page() - 1) * state.pageSize"
      [rows]="state.pageSize"
      [totalRecords]="state.items().length"
      [showJumpToPageDropdown]="false"
      (onPageChange)="onPageChange($event)"></p-paginator>
  </div>
</div>

<app-geo-image-detail-modal
  [visible]="detailVisible"
  [item]="detailItem"
  (visibleChange)="detailVisible = $event"
  (edit)="openEdit($event)"
  (delete)="openDelete($event)"></app-geo-image-detail-modal>

<app-geo-image-edit-modal
  [visible]="editVisible"
  [item]="editItem"
  [loading]="saving"
  (visibleChange)="editVisible = $event"
  (save)="saveEdit($event)"></app-geo-image-edit-modal>

<app-geo-image-delete-modal
  [visible]="deleteVisible"
  [item]="deleteItem"
  [loading]="deleting"
  (visibleChange)="deleteVisible = $event"
  (confirm)="confirmDelete()"></app-geo-image-delete-modal>
